import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { searchPlatformAccessControl } from '../access-control/searchPlatformAccess.configuration'

const SearchPlatformSearchResultsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SearchPlatformSearchResultsPage" */
      '../pages/SearchPlatformSearchResultsPage'
    )
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const searchPlatformRouter = (
  <DomainRoute route="search-platform" accessControl={searchPlatformAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="search-platform-search-results"
        component={SearchPlatformSearchResultsPage}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
